import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { BookingService } from 'src/app/services/booking.service';
import { EventType } from 'src/enum/eventtype';

// Shared send-back-to-dealer popup for the 3 new review gates in the AED post-payment flow
// (Manufacturer at Placement, AE/JE at Dealer-Premises Verification, AEE at Subsidy Release) — see
// CLAUDE.md. All 3 send-backs are functionally identical (remarks-only, straight back to the dealer),
// so one generic, parameterized popup is used instead of 3 near-duplicate ones. Modelled on the
// existing SendbackpopupComponent/AeesendbackpopupComponent, but the EventType and post-submit route
// are supplied by the caller via MAT_DIALOG_DATA instead of being hardcoded.
@Component({
  selector: 'app-sendbacktodealerpopup',
  templateUrl: './sendbacktodealerpopup.component.html',
  styleUrls: ['./sendbacktodealerpopup.component.scss']
})
export class SendbacktodealerpopupComponent implements OnInit {
  showNotes: boolean = true;
  sentbackform: FormGroup;
  id: any;
  eventType: EventType;
  navigateRoute: string;
  public eventEnum = EventType;
  sendbackDisabled: boolean;
  loading: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private router: Router,
    public dialogRef: MatDialogRef<SendbacktodealerpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    private bookingService: BookingService,
  ) {
    this.id = this.dataRecievedData.id;
    this.eventType = this.dataRecievedData.eventType;
    this.navigateRoute = this.dataRecievedData.navigateRoute;
  }

  ngOnInit(): void {
    this.showNotes = true;
    this.initializeValidators();
  }

  initializeValidators() {
    this.sentbackform = this.formBuilder.group({
      sendbackremarks: [null, Validators.required]
    });
  }

  sendbackcancel(isProceed) {
    this.dialogRef.close(isProceed);
  }

  validateFormControl() {
    Object.keys(this.sentbackform.controls).forEach((field) => {
      const control = this.sentbackform.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true,
        });
      }
    });
  }

  sendbackremarks() {
    this.sendbackDisabled = true;
    this.loading = true;
    if (this.sentbackform.valid) {
      let request = {
        id: this.id,
        eventType: this.eventType,
        remarks: this.sentbackform.value.sendbackremarks,
      };
      this.bookingService
        .sendBack(request)
        .subscribe((res) => {
          if (res) {
            this.sendbackDisabled = false;
            this.loading = false;
            this.alertService.success('Send Back Successfully');
            this.dialogRef.close();
            if (this.navigateRoute) {
              this.router.navigate([this.navigateRoute]);
            }
          }
          else {
            this.sendbackDisabled = false;
            this.loading = false;
          }
        });
    } else {
      this.sendbackDisabled = false;
      this.loading = false;
      this.validateFormControl();
    }
  }
}
